import { useUserMetadataQueryContext } from '../contexts/UserMetadataQueryContext';
import { useUserKeyParameter } from './useUserKeyParameter';

export const useUserKey = (readable: boolean = false) => {
  const paramKey = useUserKeyParameter(readable);
  const { internalUserId } = useUserMetadataQueryContext();

  // UUID projects will always have the internalUserId. Legacy email projects will use the email address, so we fallback
  // to the URI parameter for that case.
  return internalUserId ?? paramKey;
};
